<template>
    <router-view></router-view>
</template>

<script lang="ts">
    import { Component, Mixins } from 'vue-property-decorator';
    import environment from '@/environment';
    import { makeLogger } from './common/services';
    import TrackMobileModeMixin from '@/common/mixins/mobile-mode.mixin';
    import { AuthenticationServiceTokens } from './authentication/di-tokens';

    @Component({})
    export default class App extends Mixins(TrackMobileModeMixin) {
        private readonly log = makeLogger('app');
        private platformResolutionService = this.$injector.resolve(
            AuthenticationServiceTokens.PlatformResolutionService
        );

        created(): void {
            if (this.$FullStory !== undefined) {
                this.$FullStory.setUserVars({
                    environment: environment.type,
                    platform: this.platformResolutionService.getPlatformDomain(),
                });
            }
            this.log(`You are on the "%s" environment`, environment.type);
            this.log(`Client type is %o`, environment.clientType);
            this.log(`Client version is %o`, environment.clientVersion);
        }
    }
</script>
